import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ApiLocationService} from '@services/api-location/api-location.service';
import {Observable} from 'rxjs';
import {HTTPS_REQUEST_OPTIONS, HTTPS_REQUEST_OPTIONS_FOR_FILES} from '@constants/https-request-options/https-request-options';

@Injectable({
  providedIn: 'root'
})
export class DocumentationService {

  private GET_DOCUMENTATIONS_URL_SUFFIX: string = '/api/web/documentation';
  private DOWNLOAD_DOCUMENTATION_URL_SUFFIX: string = '/api/web/documentation/download/:docName';

  private readonly BASE_URL: string;

  constructor(private http: HttpClient, private apiLocationService: ApiLocationService) {
    this.BASE_URL = this.apiLocationService.getLocation();
  }

  public getDocumentations(): Observable<any> {
    const url: string = this.BASE_URL + this.GET_DOCUMENTATIONS_URL_SUFFIX;
    return this.http.get(url, HTTPS_REQUEST_OPTIONS);
  }

  public downloadDocumentation(docName: string): Observable<any> {
    let url: string = this.BASE_URL + this.DOWNLOAD_DOCUMENTATION_URL_SUFFIX;
    url = url.replace(':docName', docName);
    return this.http.get(url, HTTPS_REQUEST_OPTIONS_FOR_FILES);
  }
}
